export default "__VITE_ASSET__DlxXpFg8__"